import type { InkStroke } from '../domain/types';

/**
 * Die Handschriftseite als PNG-Data-URL — für Classics `commentImage`.
 *
 * Die alte Classic-App schickte die Skizze als `data:image/png;base64,…` im Rating mit
 * (`docs/classic-rest-api.md` §3.1); der Server gibt sie so in seinen Auswertungen aus. Stage
 * hält die Striche normiert auf 0…1 (`domain/ink.ts`) und zeichnet sie hier auf eine Leinwand:
 * schwarz auf weiss, quadratisch. 800 px reichen für den Ausdruck und halten den Rumpf von
 * `/rest/log` klein — er geht bei jedem Neusenden der Aufgabe wieder mit.
 *
 * `null`, wo es keine Leinwand gibt (Tests, Node) oder nichts gezeichnet ist.
 */
export const SKIZZE_PX = 800;

export function skizzeAlsPng(strokes: InkStroke[]): string | null {
  if (strokes.length === 0 || typeof document === 'undefined') return null;
  const leinwand = document.createElement('canvas');
  leinwand.width = SKIZZE_PX;
  leinwand.height = SKIZZE_PX;
  const g = leinwand.getContext('2d');
  if (!g) return null;
  g.fillStyle = '#fff';
  g.fillRect(0, 0, SKIZZE_PX, SKIZZE_PX);
  g.strokeStyle = '#000';
  g.fillStyle = '#000';
  // Dieselbe Strichstärke wie im SVG (0.004 der Seite).
  g.lineWidth = Math.max(2, SKIZZE_PX * 0.004);
  g.lineCap = 'round';
  g.lineJoin = 'round';
  for (const s of strokes) {
    if (s.points.length === 0) continue;
    if (s.points.length === 1) {
      const p = s.points[0];
      g.beginPath();
      g.arc(p.x * SKIZZE_PX, p.y * SKIZZE_PX, g.lineWidth / 2, 0, Math.PI * 2);
      g.fill();
      continue;
    }
    g.beginPath();
    s.points.forEach((p, i) => (i === 0 ? g.moveTo : g.lineTo).call(g, p.x * SKIZZE_PX, p.y * SKIZZE_PX));
    g.stroke();
  }
  return leinwand.toDataURL('image/png');
}
